module.exports = __webpack_public_path__ + "img/llavero1.e5f66a45.png";